/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TransactionDto } from './TransactionDto';
import {
    TransactionDtoFromJSON,
    TransactionDtoFromJSONTyped,
    TransactionDtoToJSON,
    TransactionDtoToJSONTyped,
} from './TransactionDto';

/**
 * 
 * @export
 * @interface TransactionPaginationDto
 */
export interface TransactionPaginationDto {
    /**
     * 
     * @type {number}
     * @memberof TransactionPaginationDto
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionPaginationDto
     */
    pageSize: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionPaginationDto
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionPaginationDto
     */
    nextPageToken?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionPaginationDto
     */
    hasMore?: boolean;
    /**
     * List of transactions
     * @type {Array<TransactionDto>}
     * @memberof TransactionPaginationDto
     */
    data: Array<TransactionDto>;
}

/**
 * Check if a given object implements the TransactionPaginationDto interface.
 */
export function instanceOfTransactionPaginationDto(value: object): value is TransactionPaginationDto {
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function TransactionPaginationDtoFromJSON(json: any): TransactionPaginationDto {
    return TransactionPaginationDtoFromJSONTyped(json, false);
}

export function TransactionPaginationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionPaginationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'page': json['page'],
        'pageSize': json['pageSize'],
        'total': json['total'],
        'nextPageToken': json['nextPageToken'] == null ? undefined : json['nextPageToken'],
        'hasMore': json['hasMore'] == null ? undefined : json['hasMore'],
        'data': ((json['data'] as Array<any>).map(TransactionDtoFromJSON)),
    };
}

export function TransactionPaginationDtoToJSON(json: any): TransactionPaginationDto {
    return TransactionPaginationDtoToJSONTyped(json, false);
}

export function TransactionPaginationDtoToJSONTyped(value?: TransactionPaginationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'page': value['page'],
        'pageSize': value['pageSize'],
        'total': value['total'],
        'nextPageToken': value['nextPageToken'],
        'hasMore': value['hasMore'],
        'data': ((value['data'] as Array<any>).map(TransactionDtoToJSON)),
    };
}

